import { render, staticRenderFns } from "./DotMenu.vue?vue&type=template&id=4742aa5b&scoped=true&"
import script from "./DotMenu.vue?vue&type=script&lang=js&"
export * from "./DotMenu.vue?vue&type=script&lang=js&"
import style0 from "./DotMenu.vue?vue&type=style&index=0&id=4742aa5b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4742aa5b",
  null
  
)

export default component.exports